import {
	includedPropList,
	includedT2PropList,
	minorSeasonPropsList,
} from "../../../pages/activityBuilder/modules/annualCropland/annualCropland";
import type {
	AnnualCroplandPayload,
	AnnualCroplandResponse,
	MinorSeason,
	MinorSeasonT2,
	ModuleFull,
	AnnualCroplandT2,
} from "../../../pages/activityBuilder/modules/annualCropland/annualCroplandTypes";
import { filterObjectProps, convertEmptyStringsToNull } from "../../../pages/activityBuilder/modules/inputs/utils";
import { FEModules } from "../../../utils/moduleList";
import { FEModulesObj } from "../../../utils/moduleList";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";

// Define constants for the module
const MODULE_TYPE = "AnnualCropland";
const TAG: TagTypes = "AnnualCropland";
const TAG_DEFAULTS: TagTypes = "AnnualCroplandDefaults";
const ENDPOINT = FEModulesObj[FEModules.AnnualCropland].path;
const t2PercentageProps = ["minor_biomass_factor_t2_start", "minor_biomass_factor_t2_w", "minor_biomass_factor_t2_wo"];

// const transformResponse = (response: AnnualCroplandResponse) => transformModuleResponse<AnnualCroplandResponse, ModuleFull>({
// 	response,
// 	includedPropList,
// 	includedT2PropList,
// 	t2PercentageProps
// })
const transformResponse = (response: AnnualCroplandResponse) => {
	if (response) {
		const moduleMinorSeasonData = filterObjectProps(
			response,
			minorSeasonPropsList,
		) as MinorSeason;

		const t2MinorSeasonData = filterObjectProps(response, t2PercentageProps) as MinorSeasonT2;

		const module = filterObjectProps(
			{ ...response, minorSeason: moduleMinorSeasonData },
			includedPropList,
		) as AnnualCroplandPayload;

		const t2 = filterObjectProps(
			{ ...response, minorSeason: t2MinorSeasonData },
			includedT2PropList,
		) as AnnualCroplandT2;

		return {
			module: module,
			tiertwo: t2,
		};
	}
	return null;
}

const annualCroplandApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicAnnualCroplandApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

export const {
	useGetAnnualCroplandQuery,
	useGetAnnualCroplandDefaultsQuery
} = annualCroplandApiSlice;

export const {
	useGetAnnualCroplandQuery: usePublicGetAnnualCroplandQuery,
	useGetAnnualCroplandDefaultsQuery: usePublicGetAnnualCroplandDefaultsQuery
} = publicAnnualCroplandApiSlice;

const transformUpdatePayload = (data: ModuleFull, activityId: number) => {
	const module = { ...data.module, ...data.module.minorSeason }; //there's max 1 minorSeason
	const t2 = { ...data.tiertwo, ...data.tiertwo.minorSeason }; //there's max 1 minorSeason
	const lucId = data.module.land_use_change;
	const payload = {
		...module,
		...t2,
	} as unknown as AnnualCroplandResponse;
	const { id, ...rest } = payload;
	const body = { ...rest, activity: activityId, land_use_change: lucId };
	convertEmptyStringsToNull(body);
	return { body, id };
}

const mutationApiSlice = createModuleUpdateApi<ModuleFull, AnnualCroplandResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
	includesLandUseChange: true,
})

export const {
	useUpdateAnnualCroplandMutation,
} = mutationApiSlice;
